var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-ecommerce"}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12","sm":"12"}},[(_vm.$can('tracking_read'))?_c('user-view-user-timeline-card'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }